import request from '@/utils/request'
import store from '@/store'
import axios from 'axios'

const url = store.getters.getPostUrl;
export default {
  getPage(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentRepairKnowledge/page',
      method: 'post',
      data: param,
    })
  },
  insert(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentRepairKnowledge/insert',
      method: 'post',
      data: param,
    })
  },
  update(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentRepairKnowledge/update',
      method: 'put',
      data: param,
    })
  },
  del(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentRepairKnowledge/delete',
      method: 'delete',
      params: {
        'id': param
      }
    })
  },
  exportExcel(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentRepairKnowledge/exportExcel',
      method: 'post',
      data: param,
      responseType: 'blob'
    })
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/knowledge/knowledge.js